import { safeRulesYamlLoad } from '../../common';
import { ValidationError } from '../../errors';
import ValidatorBase from '../Base';

const automationNamePattern = /^[a-zA-Z0-9_-]+$/;

const escapeQuotes = (str: string): string => {
  return str.replace(/['"`]/g, match => {
    if (match === '"') {
      return '\"';
    } else if (match === "'") {
      return "\'";
    } else if (match === '`') {
      return '\`';
    }
    return match;
  });
};

export class AutomationNamesValidator extends ValidatorBase {
  validate(args: any) {
    const { yamlFile } = args;
    let rules: any = yamlFile;

    if (typeof rules === 'string') {
      rules = safeRulesYamlLoad(yamlFile);
    }

    const invalidAutomationNames = Object.keys(rules?.automations || {}).filter(
      automationName =>
        !automationNamePattern.test(automationName) || /\s/.test(automationName)
    );

    if (invalidAutomationNames.length) {
      const escapedNames = escapeQuotes(invalidAutomationNames.join(', '));
      throw new ValidationError(
        `Unsupported automation ${
          invalidAutomationNames.length === 1 ? 'name' : 'names'
        }: \`${escapedNames}\`. Please ensure that the automation name consists only of letters (a-z, A-Z), numbers (0-9), underscores (_), and hyphens (-).`
      );
    }
  }
}
